import { getFrontEndName, getSpecOptionFrontEndName } from "@/utils/productName.utils";
import { getServiceFeeLabel } from "@/utils/serviceFee.utils";

export default class orderContentModel {
    constructor(orderContent) {
        const isMergedOrder = orderContent ? 'order_sheet' in orderContent : false
        if (isMergedOrder) {
            this._orderContent = orderContent.order_sheet
        } else {
            this._orderContent = orderContent
        }
        const children = orderContent?.combined_order_sheets || []
        this._combined_order_sheets = children.length === 0 ? [] : children.map(child => new orderContentModel(child))
        this.orderDelivering = this._orderContent?.orderDelivering || {}
    }

    get orderGoods() {
        return [...this._parentOrderGoods, ...this._childrenOrderGoods]
    }

    get _parentOrderGoods() {
        return (this._orderContent.orderGoods || []).reduce((arr, cur) => {
            let price = 0
            if (cur.combo?.standardPrice != null) {
                price = (cur.vipLevel != null) && cur.vipLevel > 1 && (cur.combo.vipPrice != null) ? cur.combo.vipPrice : cur.combo.standardPrice
            } else if (cur.product?.standardPrice != null) {
                price = (cur.vipLevel != null) && cur.vipLevel > 1 && (cur.product.vipPrice != null) ? cur.product.vipPrice : cur.product.standardPrice
            }
            // 檢查時價
            if (cur.product?.isDynamicPrice) {
                price = cur.dynamicPrice
            }
            // 檢查現場改價
            // overridePriceReason 1：打折 2：減價 3：免費 4：兌換商品
            if (cur.overridePriceReason == 1) {
                // overrideDiscountRate 現場打折
                price = price * cur.overrideDiscountRate
            } else if (cur.overridePriceReason == 2) {
                // overrideDiscountMinus 現場減價
                price = price - cur.overrideDiscountMinus
            } else if (cur.overridePriceReason == 3) {
                // overrideFree 免費
                price = 0
            } else if (cur.overridePriceReason == 4) {
                // 兌換商品：基礎價格為零，但規格加價仍會在後續計算中加入
                price = 0
            }
            let name = cur?.product?.displayName || cur?.combo?.displayName || getFrontEndName(cur?.product?.name || cur?.combo?.name || '')
            // 如果是兌換商品，在名稱前加上【兌換】標記
            if (cur.overridePriceReason == 4) {
                name = `【兌換】${name}`
            }
            // 如果是優惠券贈品，在名稱前加上【贈品】標記
            if (cur.isCouponBenefit === true) {
                name = `【贈品】${name}`
            }
            let specsPrice = 0
            let specOptions = []
            // specOption 格式
            // {
            //   title: "美式",
            //   altAddonPrice: 0,
            //   specOptions: [
            //     {
            //       title: "冰或熱",
            //       options: [
            //         "冰",
            //       ],
            //     },
            //     {
            //       title: "加點",
            //       options: [
            //         "濃縮",
            //       ],
            //     },
            //   ],
            // }
            if (cur.orderProducts === undefined) {
                // 單點商品 
                let productOption = {
                    title: '',
                    specOptions: []
                }
                const orderSpecs = cur.orderSpecs || []
                orderSpecs.forEach((setting) => {
                    if (setting.subSpecOptionSelectCount && setting.subSpecOptionSelectCount.length) {
                        const specCount = setting.subSpecOptionSelectCount.reduce((acc, count) => acc + count, 0)
                        // 如果有選擇規格
                        let specOption = {}

                        const options = []
                        setting.subSpecOptionSelectCount.forEach((count, index) => {
                            if (count !== 0) {
                                // 取得規格價錢
                                const price = setting.productSpec.specOptions[index].price
                                const priceAmount = price * count
                                specsPrice += priceAmount
                                // 並將選擇的規格加到選項中
                                const name = getSpecOptionFrontEndName(setting.productSpec.specOptions[index].name)
                                options.push(this._formatSpecOptionText(name, price, count))

                                specOption.options = options
                            }
                        })
                        if (specCount !== 0) {
                            // 將規格顯示名稱加入
                            specOption.title = setting.frontEndDisplayName
                            productOption.specOptions.push(specOption)
                        }
                    }
                })
                if (productOption.specOptions.length) {
                    specOptions.push(productOption)
                }
            } else {
                // 固定餐點
                if (cur.orderProducts && cur.orderProducts.length) {
                    cur.orderProducts.forEach((product) => {
                        if (product.orderCount) {
                            let productOption = {
                                title: product.product?.displayName || getFrontEndName(product.product?.name),
                                specOptions: []
                            }
                            if (product.orderSpecs && product.orderSpecs.length) {
                                product.orderSpecs.forEach(setting => {
                                    if (setting.subSpecOptionSelectCount && setting.subSpecOptionSelectCount.length) {
                                        const specCount = setting.subSpecOptionSelectCount.reduce((acc, count) => acc + count, 0)
                                        // 如果有選擇規格
                                        let specOption = {}
                                        const options = []
                                        setting.subSpecOptionSelectCount.forEach((count, index) => {
                                            if (count !== 0 && setting.productSpec.specOptions && setting.productSpec.specOptions.length) {
                                                // 取得規格價錢
                                                let price = 0
                                                if (setting.productSpec && setting.productSpec.specOptions && setting.productSpec.specOptions[index]) {
                                                    price = setting.productSpec.specOptions[index].price
                                                    // 並將選擇的規格加到選項中
                                                    const name = getSpecOptionFrontEndName(setting.productSpec.specOptions[index].name)
                                                    options.push(this._formatSpecOptionText(name, price, count))
                                                }
                                                const priceAmount = price * count
                                                specsPrice += priceAmount

                                                specOption.options = options
                                                // productOption.specOptions.push(specOption)
                                            }
                                        })
                                        if (specCount !== 0) {
                                            // 將規格顯示名稱加入
                                            specOption.title = setting.frontEndDisplayName
                                            productOption.specOptions.push(specOption)
                                        }
                                    }
                                })
                            }
                            if (productOption.specOptions.length) {
                                specOptions.push(productOption)
                            }
                        }
                    })
                }


                // 套餐子項
                if (cur.orderComboSubs && cur.orderComboSubs.length) {
                    for (const group of cur.orderComboSubs) {
                        if (group.orderProducts && group.orderProducts.length) {
                            group.orderProducts.forEach(product => {
                                let productOption = {
                                    title: product.product?.displayName || getFrontEndName(product.product.name),
                                    specOptions: []
                                }
                                // 計算套餐子項項量
                                if (product.orderCount && product.orderCount > 1) {
                                    productOption.count = product.orderCount
                                }
                                // 計算套餐子項加價
                                if (product.altAddonPrice) {
                                    productOption.altAddonPrice = product.altAddonPrice
                                    specsPrice += product.orderCount * product.altAddonPrice
                                }
                                // 計算商品規格加價
                                if (product.orderSpecs && product.orderSpecs.length) {
                                    product.orderSpecs.forEach(setting => {
                                        if (setting.subSpecOptionSelectCount && setting.subSpecOptionSelectCount.length) {
                                            const specCount = setting.subSpecOptionSelectCount.reduce((acc, count) => acc + count, 0)
                                            // 如果有選擇規格
                                            let specOption = {}
                                            const options = []
                                            setting.subSpecOptionSelectCount.forEach((count, index) => {
                                                if (count !== 0) {
                                                    // 取得規格價錢
                                                    let price = 0
                                                    if (setting.productSpec && setting.productSpec.specOptions.length >= index && setting.productSpec.specOptions[index]) {
                                                        price = setting.productSpec.specOptions[index].price
                                                        // 並將選擇的規格加到選項中
                                                        const name = getSpecOptionFrontEndName(setting.productSpec.specOptions[index].name)
                                                        options.push(this._formatSpecOptionText(name, price, count))
                                                    }
                                                    // console.log(setting.productSpec.specOptions)
                                                    const priceAmount = price * count
                                                    specsPrice += priceAmount

                                                    specOption.options = options
                                                }
                                            })
                                            if (specCount !== 0) {
                                                // 將規格顯示名稱加入
                                                specOption.title = setting.productSpec.frontEndDisplayName || getFrontEndName(setting.productSpec.name)
                                                productOption.specOptions.push(specOption)
                                            }
                                        }
                                    })
                                }
                                if (productOption.specOptions.length || productOption.title) {
                                    specOptions.push(productOption)
                                }
                            })
                        }
                    }
                }



                // 套餐任選子項
                if (cur.orderComboSubAny && cur.orderComboSubAny.orderProducts && cur.orderComboSubAny.orderProducts.length) {
                    cur.orderComboSubAny.orderProducts.forEach(product => {
                        if (product.orderCount && product.product) {
                            let productOption = {
                                title: product.product?.displayName || getFrontEndName(product.product.name),
                                specOptions: []
                            }
                            // 任選子項不需要加上商品價格 只需要加上規格價格
                            // specsPrice += product.orderCount * product.product.standardPrice
                            if (product.orderSpecs && product.orderSpecs.length) {
                                product.orderSpecs.forEach(setting => {
                                    if (setting.subSpecOptionSelectCount && setting.subSpecOptionSelectCount.length) {
                                        const specCount = setting.subSpecOptionSelectCount.reduce((acc, count) => acc + count, 0)
                                        // 如果有選擇規格
                                        let specOption = {}
                                        const options = []
                                        setting.subSpecOptionSelectCount.forEach((count, index) => {
                                            if (count !== 0) {
                                                // 取得規格價錢
                                                let price = 0
                                                if (setting.productSpec && setting.productSpec.specOptions[index]) {
                                                    price = setting.productSpec.specOptions[index].price * count
                                                    // 並將選擇的規格加到選項中
                                                    options.push(`${getSpecOptionFrontEndName(setting.productSpec.specOptions[index].name)}${count > 1 ? ` x${count}` : ''}`)
                                                }
                                                specsPrice += price
                                                if (price) {
                                                    options.push(price)
                                                }
                                                specOption.options = options
                                            }
                                        })
                                        if (specCount !== 0) {
                                            // 將規格顯示名稱加入
                                            specOption.title = setting.frontEndDisplayName
                                            productOption.specOptions.push(specOption)
                                        }
                                    }
                                })
                            }
                            if (productOption.specOptions.length) {
                                specOptions.push(productOption)
                            }
                        }
                    })
                }
            }

            arr.push({
                productName: name,
                count: cur.orderCount,
                price: price,
                // displayPrice 需要以 (單價 + 加價項目 + 規格加價) * 數量 來計算
                displayPrice: (Number(price) + Number(specsPrice)) * Number(cur.orderCount),
                selectedSpecOptions: specOptions || [],
                note: cur.note || ''
            })
            return arr
        }, [])
    }

    get _childrenOrderGoods() {
        return this._combined_order_sheets.reduce((arr, cur) => {
            arr.push(...cur.orderGoods)
            return arr
        }, [])
    }

    get _parentPaymentType() {
        return this._orderContent.orderCheckout.paymentType || []
    }

    get _childrenPaymentType() {
        return this._combined_order_sheets.reduce((arr, cur) => {
            arr.push(cur.orderCheckout.paymentType)
            return arr
        }, [])
    }

    // 取餐時間
    get deliverTime() {
        return this.orderDelivering.deliverTime || ''
    }

    get deliveryPeriod() {
        return this.orderDelivering.deliveryPeriod || ''
    }

    // 子單
    get isChildOrder() {
        return this._orderContent.hostOrderSheetID
    }

    // 主單
    get isParentOrder() {
        return this._orderContent.hostOrderSheetID == null
    }

    // 訂單備註
    get orderNote() {
        return this.orderCheckout.note || ''
    }

    // 付款方式
    get paymentType() {
        return [...new Set([this._parentPaymentType, ...this._childrenPaymentType])]
    }

    get orderCheckout() {
        return this._orderContent.orderCheckout;
    }

    // 訂單總金額 尚未減去任何折扣 積點 額外費用
    get totalPrice() {
        return this._combined_order_sheets.reduce((total, childOrder) => {
            return total + childOrder.totalPrice
        }, this._getParentOrderTotalPrice())
    }

    get totalPriceAfterDiscount() {
        const priceAfterDiscount = this.totalPrice - this.onSiteDiscount - this.discountPrice - this.couponDiscount + this.extraFee
        return priceAfterDiscount < 0 ? 0 : priceAfterDiscount
    }

    get storeServiceFeeSetting() {
        return this.orderCheckout.storeServiceFeeSetting || {}
    }

    get isDineIn() {
        return this.orderDelivering.mode === 0
    }

    get serviceFeeLabel() {
        return getServiceFeeLabel(this.storeServiceFeeSetting.serviceFeeName)
    }

    // 服務費
    get serviceFee() {
        // 如果是子單不顯示服務費
        if (this.isChildOrder) return 0
        // 只有內用才會有服務費
        if (!this.isDineIn) return 0
        // fromOriginalRate 是從原價計算
        // afterDiscountRate 是從折扣後計算
        // serviceFeeCalc 0 不計算 1 依照原價 2 依照折扣後價格
        if (!this.storeServiceFeeSetting || !this.storeServiceFeeSetting.serviceFeeCalc) return 0
        if (this.storeServiceFeeSetting.serviceFeeCalc === 0) return 0

        // 判斷是否為合併訂單
        const isMergedOrder = this._combined_order_sheets.length > 0

        if (isMergedOrder) {
            // 合併訂單計算邏輯
            return this._calculateMergedOrderServiceFee()
        } else {
            // 單一訂單計算邏輯
            return this._calculateSingleOrderServiceFee()
        }
    }

    // 額外費用
    get extraFee() {
        return Math.abs(this.orderCheckout.extraFee) || 0
    }

    // 現場折價：先扣優惠券，再套用主單折扣率
    get discountPrice() {
        return this._calculateDiscountPrice(this.totalPrice, this.couponDiscount)
    }

    // 現場折價 打幾折
    get discountRate() {
        return Number(this.orderCheckout.discountRate ?? 1)
    }

    // 現場減價
    get onSiteDiscount() {
        return Math.abs(this.orderCheckout.onSiteDiscount) || 0
    }

    // 紅利積點減價（pointDiscount + prePointDiscount，null 視為 0）
    get pointDiscount() {
        return Math.abs((this.orderCheckout.pointDiscount || 0) + (this.orderCheckout.prePointDiscount || 0)) || 0
    }

    // 優惠券折抵金額（couponDiscountAmount 優先，舊欄位 couponDiscount 為備援）
    get couponDiscount() {
        return this._combined_order_sheets.reduce((total, childOrder) => {
            return total + childOrder.couponDiscount
        }, this._parentCouponDiscount)
    }

    get _parentCouponDiscount() {
        return Math.abs(this.orderCheckout.couponDiscountAmount ?? this.orderCheckout.couponDiscount) || 0
    }

    // 優惠券名稱
    get couponTitle() {
        return this.orderCheckout.couponTitle || this.orderCheckout.couponPublicRules?.title || ''
    }

    // 刷卡手續費
    get creditCardSurcharge() {
        return Math.abs(this.orderCheckout.creditCardSurcharge) || 0
    }

    // 運費（僅外送訂單）
    get shippingFee() {
        // 店家外送(3) / 零售宅配(5) 才有運費
        if (![3, 5].includes(this.orderDelivering.mode)) return 0
        return Math.abs(this.orderCheckout.shippingFee) || 0
    }

    // 外送地址
    get deliveryAddress() {
        if (![3, 5].includes(this.orderDelivering.mode)) return ''
        return this.orderDelivering.address || ''
    }

    // 外送聯絡人
    get deliveryRecipient() {
        if (![3, 5].includes(this.orderDelivering.mode)) return ''
        return this.orderDelivering.recipient || ''
    }

    // 外送聯絡電話
    get deliveryContactPhone() {
        if (![3, 5].includes(this.orderDelivering.mode)) return ''
        return this.orderDelivering.contactPhone || ''
    }

    // 統一編號
    get vatNumber() {
        return this.orderCheckout.buyerTaxID || ''
    }

    get hasAdditionalFee() {
        return this.serviceFee !== 0 || this.extraFee !== 0 || this.pointDiscount !== 0 || this.couponDiscount !== 0 || this.onSiteDiscount !== 0 || this.discountPrice != 0 || this.creditCardSurcharge !== 0 || this.shippingFee !== 0
    }

    // 全單規格
    get orderSpecs() {
        return this._orderContent.orderSpecs || []
    }

    get orderSpecPrice() {
        let orderSpecPrice = 0
        if (this.orderSpecs.length) {
            for (const setting of this.orderSpecs) {
                if (setting.productSpec && setting.productSpec.specOptions && setting.productSpec.specOptions.length) {
                    orderSpecPrice += setting.productSpec.specOptions.reduce((total, spec, index) => {
                        return total += spec.price * setting.subSpecOptionSelectCount[index]
                    }, 0)
                }
            }
        }
        return orderSpecPrice
    }

    get orderSpecOptions() {
        return this.orderSpecs.map(setting => {
            if (setting.subSpecOptionSelectCount != null && setting.subSpecOptionSelectCount.length) {
                const specCount = setting.subSpecOptionSelectCount.reduce((acc, count) => acc + count, 0)
                if (specCount === 0) return {}
                // 如果有選擇規格
                let specOption = {}
                const options = []
                setting.subSpecOptionSelectCount.forEach((count, index) => {
                    if (setting.productSpec?.specOptions == null) return
                    if (count !== 0 && setting.productSpec.specOptions != null && setting.productSpec.specOptions.length) {
                        // 取得規格價錢
                        let price = 0
                        if (setting.productSpec.specOptions[index].price) {
                            price = setting.productSpec.specOptions[index].price * count
                        }
                        // 並將選擇的規格加到選項中
                        if (setting.productSpec.specOptions[index].name) {
                            options.push(getSpecOptionFrontEndName(setting.productSpec.specOptions[index].name))
                        }
                        if (price) {
                            options.push(price)
                        }
                        specOption.options = options
                    }
                }
                )
                if (specCount !== 0) {
                    // 將規格顯示名稱加入
                    specOption.title = setting.frontEndDisplayName
                    return specOption
                }
            } else {
                return {}
            }
        }).filter(option => option.title) || []
    }

    get displayOrderSpecOptionsText() {
        return this.orderSpecOptions.map(option => {
            let text = option.title
            if (option.options && option.options.length) {
                text += '：' + option.options.join('、')
            }
            return text
        }).join('、')
    }

    _formatSpecOptionText(name, price, count) {
        let text = name;

        // 處理價格顯示
        if (price > 0) {
            text += `+${price}`;
        } else if (price < 0) {
            text += `${price}`;  // 負數自帶負號
        }
        // price === 0 時不顯示價格

        // 處理數量
        if (count > 1) {
            text += ` x${count}`;
        }

        return text;
    }

    // 計算單一訂單服務費
    _calculateSingleOrderServiceFee() {
        let serviceFee = 0
        if (this.storeServiceFeeSetting.serviceFeeCalc === 1) {
            // 依照原價
            serviceFee = (this.totalPrice * this.storeServiceFeeSetting.fromOriginalRate).toFixed(2)
        }
        if (this.storeServiceFeeSetting.serviceFeeCalc === 2) {
            // 依照折扣後價格
            serviceFee = (this.totalPriceAfterDiscount * this.storeServiceFeeSetting.afterDiscountRate).toFixed(2)
        }
        return Math.round(Number(serviceFee))
    }

    // 計算合併訂單服務費
    _calculateMergedOrderServiceFee() {
        let totalServiceFee = 0

        if (this.storeServiceFeeSetting.serviceFeeCalc === 1) {
            // 依照原價計算
            // 主單服務費
            const parentServiceFee = this._getParentOrderTotalPrice() * this.storeServiceFeeSetting.fromOriginalRate
            totalServiceFee += Math.round(parentServiceFee)

            // 各子單服務費
            this._combined_order_sheets.forEach(childOrder => {
                const childServiceFee = this._getChildOrderTotalPrice(childOrder) * this.storeServiceFeeSetting.fromOriginalRate
                totalServiceFee += Math.round(childServiceFee)
            })
        }

        if (this.storeServiceFeeSetting.serviceFeeCalc === 2) {
            // 依照折扣後價格計算
            // 主單服務費
            const parentServiceFee = this._getParentOrderTotalPriceAfterDiscount() * this.storeServiceFeeSetting.afterDiscountRate
            totalServiceFee += Math.round(parentServiceFee)

            // 各子單服務費
            this._combined_order_sheets.forEach(childOrder => {
                const childServiceFee = this._getChildOrderTotalPriceAfterDiscount(childOrder) * this.storeServiceFeeSetting.afterDiscountRate
                totalServiceFee += Math.round(childServiceFee)
            })
        }

        return totalServiceFee
    }

    // 取得主單總金額
    _getParentOrderTotalPrice() {
        const parentOrderGoods = this._parentOrderGoods
        const total = parentOrderGoods.reduce((total, cur) => {
            total += cur.displayPrice
            return total
        }, 0)
        return this.orderSpecPrice + total
    }

    // 取得主單折扣後金額
    _getParentOrderTotalPriceAfterDiscount() {
        const parentTotalPrice = this._getParentOrderTotalPrice()
        const parentDiscountPrice = this._getParentDiscountPrice()
        const parentOnSiteDiscount = this.onSiteDiscount
        const priceAfterDiscount = parentTotalPrice - this._parentCouponDiscount - parentOnSiteDiscount - parentDiscountPrice + this.extraFee
        return priceAfterDiscount < 0 ? 0 : priceAfterDiscount
    }

    // 取得主單折扣金額
    _getParentDiscountPrice() {
        return this._calculateDiscountPrice(this._getParentOrderTotalPrice(), this._parentCouponDiscount)
    }

    // 取得子單總金額
    _getChildOrderTotalPrice(childOrder) {
        return childOrder.totalPrice
    }

    // 取得子單折扣後金額
    _getChildOrderTotalPriceAfterDiscount(childOrder) {
        const childTotalPrice = this._getChildOrderTotalPrice(childOrder)
        const childDiscountPrice = this._getChildDiscountPrice(childOrder)
        const childOnSiteDiscount = Math.abs(childOrder.orderCheckout.onSiteDiscount) || 0
        const childExtraFee = Math.abs(childOrder.orderCheckout.extraFee) || 0
        const priceAfterDiscount = childTotalPrice - childOrder.couponDiscount - childOnSiteDiscount - childDiscountPrice + childExtraFee
        return priceAfterDiscount < 0 ? 0 : priceAfterDiscount
    }

    // 取得子單折扣金額
    _getChildDiscountPrice(childOrder) {
        return this._calculateDiscountPrice(this._getChildOrderTotalPrice(childOrder), childOrder.couponDiscount)
    }

    _calculateDiscountPrice(totalPrice, couponDiscount) {
        const priceAfterCoupon = Math.max(0, totalPrice - couponDiscount)
        return Number((priceAfterCoupon - priceAfterCoupon * this.discountRate).toFixed(2))
    }
}
